import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import PaymentyPage from '../questionnaire-wizard/payment/payment.page';
import { DialogContent } from '@mui/material';

const UpdatePaymentMethod = ({ businessId, openDialog, setOpenDialog, setLoader }) => {
  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  return (
    <Dialog
      open={openDialog}
      onClose={handleDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <PaymentyPage
          businessId={businessId}
          setLoader={setLoader}
          openDialog={setOpenDialog}
          isEditMode
        />
      </DialogContent>
    </Dialog>
  );
};

export default UpdatePaymentMethod;

UpdatePaymentMethod.propTypes = {
  businessId: PropTypes.number.isRequired,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  setLoader: PropTypes.func.isRequired,
};
